// Empty result with a single primary action slot. Always renders a
// hierarchical headline → description → CTA so the eye lands the same way
// across the app.
import { Empty, Typography } from 'antd';

const { Title, Paragraph } = Typography;

export default function EmptyState({ title, description, image, action, padded = true }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: padded ? '4rem 1rem' : 0,
      }}
    >
      <Empty image={image ?? Empty.PRESENTED_IMAGE_SIMPLE} description={null} />
      {title ? (
        <Title level={4} style={{ marginTop: 16, marginBottom: 4 }}>
          {title}
        </Title>
      ) : null}
      {description ? (
        <Paragraph type="secondary" style={{ maxWidth: 420 }}>
          {description}
        </Paragraph>
      ) : null}
      {action ? <div style={{ marginTop: 8 }}>{action}</div> : null}
    </div>
  );
}
